<app-navbar [title]="pageTitle">
	<div class="id">(id: {{ event.newId }})</div>

	<button class="btn btn-primary me-2" (click)="seasonOpen()"><i class="fas fa-link"></i> Sezon</button>
	<button class="btn btn-primary me-2" (click)="linkOpen()"><i class="fas fa-link"></i> Połącz</button>
	<a
		routerLink="/eventBusiness/{{ event.id }}/payments"
		class="btn btn-primary me-2"
		*ngIf="auth.permissionsByCode()[Permissions.EVENT_BUSINESS_PAYMENTS]"
	>
		<i class="fas fa-hand-holding-usd"></i> Płatności
	</a>
	<a routerLink="./history" class="btn btn-secondary me-2"> <i class="fas fa-history"></i> Historia </a>
	<button class="btn btn-warning me-2" *ngIf="lockEdit" (click)="deleteAsk()">Usuń</button>
	<button class="btn btn-primary me-2" *ngIf="!lockEdit" (click)="submit('save')">Zapisz</button>
	<button class="btn btn-primary me-2" *ngIf="lockEdit" (click)="editUnlock()">Edycja</button>
	<button class="btn btn-primary me-2" (click)="save(false, 'copy')">Kopiuj</button>
	<a routerLink="/tourism-calendar/" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>

<div class="alert alert-danger" *ngIf="editable && !lockEdit">
	<p>Pozostały czas: {{ lockTimerText }}</p>
	<button class="btn btn-light" (click)="editUnlock()">Odśwież</button>
</div>

<app-tourism-events-link [eventId]="event.id"></app-tourism-events-link>
<app-tourism-events-season [eventId]="event.id"></app-tourism-events-season>

<app-drivers-salary-days [driver]="driverSelected" (closed)="driverSelectedClose()"></app-drivers-salary-days>

<app-drivers-event-add [event]="event"></app-drivers-event-add>

<div class="modal fade" id="askModalDelete" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Czy na pewno usunąć?</h5>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="deleteClose()">
					Nie
				</button>
				<button type="button" class="btn btn-primary" (click)="deleteConfirm()">Tak</button>
			</div>
		</div>
	</div>
</div>

<div class="modal fade" id="reportErrorDialog" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-body">
				<div class="form-floating">
					<textarea
						class="form-control"
						id="reportErrorComment"
						name="reportErrorComment"
						[(ngModel)]="reportErrorComment"
					></textarea>
					<label for="reportErrorComment">Komentarz</label>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="reportErrorClose()">
					Anuluj
				</button>
				<button type="button" class="btn btn-primary" (click)="reportErrorConfirm()">Wyślij</button>
			</div>
		</div>
	</div>
</div>

<div class="alert alert-danger" role="alert" *ngIf="event.errorsCount > 0">
	Ilość brakujących informacji w polach: {{ event.errorsCount }}
</div>
<div class="container my-4">
	<ul class="nav nav-tabs" id="myTab" role="tablist">
		<li class="nav-item">
			<a
				class="nav-link active"
				id="podstawowe-tab"
				data-bs-toggle="tab"
				href="#podstawowe"
				role="tab"
				aria-controls="podstawowe"
				aria-selected="false"
				>Podstawowe</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="sale-tab"
				data-bs-toggle="tab"
				href="#sale"
				role="tab"
				aria-controls="sale"
				aria-selected="false"
				*ngIf="RentCategory.includes(event.category)"
				>Sprzedaż</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="program-tab"
				data-bs-toggle="tab"
				href="#program"
				role="tab"
				aria-controls="program"
				aria-selected="false"
				*ngIf="!RentCategory.includes(event.category)"
				>Program</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="drivers-tab"
				data-bs-toggle="tab"
				href="#drivers"
				role="tab"
				aria-controls="drivers"
				aria-selected="false"
				>Kierowcy</a
			>
		</li>

		<li class="nav-item">
			<a
				class="nav-link"
				id="organisation-tab"
				data-bs-toggle="tab"
				href="#organisation"
				role="tab"
				aria-controls="organisation"
				aria-selected="false"
				>Organizacja</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="briefing-tab"
				data-bs-toggle="tab"
				href="#briefing"
				role="tab"
				aria-controls="briefing"
				aria-selected="false"
				>Odprawa</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="settlement-tab"
				data-bs-toggle="tab"
				href="#settlement"
				role="tab"
				aria-controls="settlement"
				aria-selected="false"
				>Rozliczenia / Wynajem</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="documents-tab"
				data-bs-toggle="tab"
				href="#documents"
				role="tab"
				aria-controls="documents"
				aria-selected="false"
				>Dokumenty</a
			>
		</li>
		<li class="nav-item">
			<a
				class="nav-link"
				id="tasks-tab"
				data-bs-toggle="tab"
				href="#tasks"
				role="tab"
				aria-controls="tasks"
				aria-selected="false"
				>Zadania</a
			>
		</li>
		<li class="nav-item">
			<div class="nav-link">ID: {{ event.newId }}</div>
		</li>
	</ul>
	<form class="my-4">
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade active show" id="podstawowe" role="tabpanel" aria-labelledby="podstawowe-tab">
				<fieldset [disabled]="lockEdit">
					<div class="form-floating mb-3">
						<input
							class="form-control"
							id="name"
							name="name"
							[(ngModel)]="event.name"
							[ngClass]="{ error: this.errors.name }"
						/>
						<label for="name">Nazwa wydarzenia</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="datetime-local"
							class="form-control"
							name="date_from"
							id="date_from"
							[ngModel]="event.date_from | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="
								event.date_from = $event;
								calculateDateTo();
								calculateDatePrepare();
								calculateDateDeadline();
								calculateDateAuto()
							"
							[ngClass]="{
								error: this.errors.date_from,
							}"
						/>
						<label for="date_from">Data rozpoczęcia</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="datetime-local"
							class="form-control"
							name="date_to"
							id="date_to"
							[ngModel]="event.date_to | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="event.date_to = $event; calculateDateDeadline(); calculateDateAuto()"
							[ngClass]="{
								error: this.errors.date_to,
							}"
						/>
						<label for="date_to">Data zakończenia</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="datetime-local"
							class="form-control"
							name="date_deadline"
							id="date_deadline"
							[ngModel]="event.date_deadline | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="event.date_deadline = $event"
							[readonly]="event.dateDeadlineAuto"
						/>
						<label for="date_deadline">Data potwierdzenia</label>
					</div>
					<div class="form-check mb-3">
						<input
							class="form-check-input"
							type="checkbox"
							name="dateDeadlineAuto"
							[(ngModel)]="event.dateDeadlineAuto"
							id="dateDeadlineAuto"
							(change)="calculateDateDeadline()"
							[disabled]="
								!auth.permissionsByCode()[Permissions.VEHICLES_EVENTS_DISABLE_AUTO_DATES_CONFIRMS]
							"
						/>
						<label class="form-check-label" for="dateDeadlineAuto"> Automatyczna data potwierdzenia </label>
					</div>
					<div class="form-floating mb-3">
						<select
							class="form-select"
							id="category"
							name="category"
							[(ngModel)]="selectedCategory"
							[ngClass]="{
								error: this.errors.category,
							}"
							(change)="categoryChanged()"
						>
							<option value="{{ item.id }}" *ngFor="let item of categories">
								{{ item.name }}
							</option>
						</select>
						<label for="category">Kategoria</label>
					</div>
					<div class="mb-3">
						<app-tourism-events-vehicle-add
							[min]="event.date_from"
							[max]="event.date_to"
							[vehicles]="vehicles"
							[editable]="lockEdit"
							[alreadyAddedVehicles]="event.vehicles"
							(emitVehiclesArray)="setVehicles($event)"
						></app-tourism-events-vehicle-add>
					</div>
					<div class="mb-3">
						<label class="form-label" for="owner">Opiekun</label>
						<ng-select
							id="owner"
							name="owner"
							[(ngModel)]="event.owner"
							placeholder="(wybierz)"
							bindLabel="name"
							[disabled]="lockEdit"
							[multiple]="true"
							[ngClass]="{ error: this.errors.owner }"
							required
						>
							<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<select class="form-select" id="status" name="status" [(ngModel)]="event.status">
							<option value="{{ item.id }}" *ngFor="let item of statuses">
								{{ item.name }}
							</option>
						</select>
						<label for="status">Status</label>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="sale" role="tabpanel" aria-labelledby="sale-tab">
				<fieldset [disabled]="lockEdit">
					<div class="row align-items-center">
						<div class="card mb-3" id="client">
							<div class="card-body">
								<label class="labelcard" for="client">Klient</label>

								<div class="row">
									<div class="col-5">
										<app-tourism-events-organization
											[client]="event.client"
											(clientData)="sendData($event)"
										></app-tourism-events-organization>
									</div>
									<div class="col-3">
										<div class="form-floating mb-3">
											<input
												type="number"
												step="1"
												min="0"
												class="form-control"
												id="people"
												name="people"
												[(ngModel)]="event.people"
											/>
											<label for="people">Planowana ilość osób</label>
										</div>
									</div>
									<div class="col-3">
										<div class="form-floating mb-3">
											<span
												class="btn"
												[ngClass]="{
													'btn-success': event.people_confirmed,
													'btn-outline-danger': !event.people_confirmed,
												}"
												(click)="event.people_confirmed = !event.people_confirmed"
												>Ilość osób jest potwierdzona</span
											>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-4 mb-3">
										<div class="form-floating">
											<input
												type="text"
												class="form-control"
												name="client_representative"
												id="client_representative"
												[(ngModel)]="event.client_representative"
											/>
											<label for="client_representative"
												>Klient - przedstawiciel na miejscu</label
											>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-11">
										<label for="client_wishes">Wymagania klienta i świadczenia</label>
										<ckeditor
											id="client_wishes_sale"
											name="client_wishes_sale"
											[(ngModel)]="event.client_wishes"
											[editor]="editor"
											[disabled]="lockEdit"
											[config]="editorConfig"
										></ckeditor>
									</div>
									<div class="col-1">
										<div
											(click)="
												reportErrorOpen(
													'client_representative',
													'Klient - przedstawiciel na miejscu'
												)
											"
										>
											<i class="fas fa-exclamation-triangle text-info"></i>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="card mb-3" id="start">
							<div class="card-body">
								<label class="labelcard" for="start ">Podstawienie</label>
								<div class="row mb-3">
									<div class="col-3">
										<div class="form-floating mb-3">
											<input
												type="datetime-local"
												class="form-control"
												name="startDate"
												id="startDate"
												[ngModel]="event.startDate | date: 'yyyy-MM-ddTHH:mm'"
												(ngModelChange)="event.startDate = $event"
											/>
											<label for="startDate">Data podstawienia</label>
										</div>
									</div>
									<div class="col-4">
										<div class="form-floating mb-3">
											<input
												type="text"
												class="form-control"
												name="startPlace"
												id="startPlace"
												[(ngModel)]="event.startPlace"
												(change)="startPlaceChanged()"
											/>
											<label for="startPlace">Miejsce podstawienia (dokładny adres)</label>
										</div>
									</div>
									<div class="col-2">
										<div class="form-floating mb-3">
											<input
												type="text"
												class="form-control"
												name="startPlaceCity"
												id="startPlaceCity"
												[(ngModel)]="event.startPlaceCity"
												(change)="startPlaceChanged()"
											/>
											<label for="startPlaceCity">Miasto podstawienia</label>
										</div>
									</div>

									<div class="col-1">
										<div class="form-floating mb-3">
											<input
												type="text"
												class="form-control"
												name="startPostCode"
												id="startPostCode"
												[(ngModel)]="event.startPostCode"
												(change)="startPlaceChanged()"
											/>
											<label for="startPostCode">Kod </label>
										</div>
									</div>

									<div class="col-1">
										<div class="form-floating mb-3">
											<span
												class="btn"
												[ngClass]="{
													'btn-success': event.departure_place_confirmed,
													'btn-outline-danger': !event.departure_place_confirmed,
												}"
												(click)="
													event.departure_place_confirmed = !event.departure_place_confirmed
												"
												>Potwierdzone
											</span>
										</div>
									</div>
								</div>
								<div class="row mb-3">
									<div class="col-11">
										<label class="form-label" for="trasaWyjazd_sale">Trasa/rozkład wyjazd</label>
										<ckeditor
											id="trasaWyjazd_sale"
											name="trasaWyjazd_sale"
											[(ngModel)]="event.text_departure"
											[editor]="editor"
											[disabled]="lockEdit"
											[config]="editorConfig"
										></ckeditor>
									</div>
									<div
										class="col-1 text-center align-self-center cursor-pointer"
										(click)="reportErrorOpen('text_departure', 'Trasa przejazdu')"
									>
										<i class="fas fa-exclamation-triangle text-info"></i>
									</div>
								</div>
							</div>
						</div>

						<div class="card mb-3" id="programSale">
							<div class="card-body">
								<label class="labelcard" for="programSale ">Program</label>
								<div class="row mb-3">
									<div class="col-4">
										<div class="form-floating mb-3">
											<span
												class="btn"
												[ngClass]="{
													'btn-success': event.detail_about_first_day_confirmed,
													'btn-outline-danger': !event.detail_about_first_day_confirmed,
												}"
												(click)="
													event.detail_about_first_day_confirmed =
														!event.detail_about_first_day_confirmed
												"
												>Szczegóły dot. pierwszego dnia
											</span>
										</div>
									</div>
									<div class="col-4">
										<div class="form-floating mb-3">
											<span
												class="btn"
												[ngClass]="{
													'btn-success': event.detail_about_program_confirmed,
													'btn-outline-danger': !event.detail_about_program_confirmed,
												}"
												(click)="
													event.detail_about_program_confirmed =
														!event.detail_about_program_confirmed
												"
												>Program jest szczegółowy
											</span>
										</div>
									</div>
									<div class="col-4">
										<div class="form-floating mb-3">
											<span
												class="btn"
												[ngClass]="{
													'btn-success': event.detail_about_last_day_confirmed,
													'btn-outline-danger': !event.detail_about_last_day_confirmed,
												}"
												(click)="
													event.detail_about_last_day_confirmed =
														!event.detail_about_last_day_confirmed
												"
												>Szczegóły dot. ostatniego dnia
											</span>
										</div>
									</div>
								</div>
								<div class="row mb-3">
									<div class="col-11">
										<label class="form-label" for="programWyjazdu_sale">Program wyjazdu</label>
										<ckeditor
											id="programWyjazdu_sale"
											name="programWyjazdu_sale"
											[(ngModel)]="event.text_program"
											[editor]="editor"
											[disabled]="lockEdit"
											[config]="editorConfig"
										></ckeditor>
									</div>
									<div
										class="col-1 text-center align-self-center cursor-pointer"
										(click)="reportErrorOpen('text_program', 'Program wyjazdu')"
									>
										<i class="fas fa-exclamation-triangle text-info"></i>
									</div>
								</div>
							</div>
						</div>

						<div class="card mb-3" id="end">
							<div class="card-body">
								<label class="labelcard" for="end ">Odstawienie</label>
								<div class="row">
									<div class="col-3">
										<div class="form-floating mb-3">
											<input
												type="datetime-local"
												class="form-control"
												name="endDate"
												id="endDate"
												[ngModel]="event.endDate | date: 'yyyy-MM-ddTHH:mm'"
												(ngModelChange)="event.endDate = $event"
											/>
											<label for="endDate">Data odstawienia</label>
										</div>
									</div>
									<div class="col-4">
										<div class="form-floating mb-3">
											<input
												type="text"
												class="form-control"
												name="endPlace"
												id="endPlace"
												[(ngModel)]="event.endPlace"
											/>
											<label for="endPlace">Miejsce odstawienia (dokładny adres)</label>
										</div>
									</div>
									<div class="col-2">
										<div class="form-floating mb-3">
											<input
												type="text"
												class="form-control"
												name="endPlaceCity"
												id="endPlaceCity"
												[(ngModel)]="event.endPlaceCity"
												(change)="startPlaceChanged()"
											/>
											<label for="endPlaceCity">Miasto odstawienia</label>
										</div>
									</div>

									<div class="col-1">
										<div class="form-floating mb-3">
											<input
												type="text"
												class="form-control"
												name="endPostCode"
												id="endPostCode"
												[(ngModel)]="event.endPostCode"
											/>
											<label for="endPostCode">Kod </label>
										</div>
									</div>

									<div class="col-1">
										<div class="form-floating mb-3">
											<span
												class="btn"
												[ngClass]="{
													'btn-success': event.return_place_confirmed,
													'btn-outline-danger': !event.return_place_confirmed,
												}"
												(click)="event.return_place_confirmed = !event.return_place_confirmed"
												>Potwierdzone
											</span>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-11">
										<label class="form-label" for="trasaPowrót_sale">Trasa/rozkład powrót</label>
										<ckeditor
											id="trasaPowrót_sale"
											name="trasaPowrót_sale"
											[(ngModel)]="event.text_return"
											[editor]="editor"
											[disabled]="lockEdit"
											[config]="editorConfig"
										></ckeditor>
									</div>
									<div
										class="col-1 text-center align-self-center cursor-pointer"
										(click)="reportErrorOpen('text_return', 'Trasa/rozkład powrót')"
									>
										<i class="fas fa-exclamation-triangle text-info"></i>
									</div>
								</div>
							</div>
						</div>

						<div class="card mb-3" id="benefits">
							<div class="card-body">
								<label class="labelcard" for="benefits ">Świadczenia</label>
								<div class="row">
									<div class="col">
										<ng-select
											id="night"
											name="night"
											[(ngModel)]="event.night"
											placeholder="Nocleg"
											[multiple]="false"
											[disabled]="lockEdit"
										>
											<ng-option *ngFor="let item of accomodationKinds" [value]="item.id">{{
												item.name
											}}</ng-option>
										</ng-select>
									</div>
									<div class="col">
										<ng-select
											id="board"
											name="board"
											placeholder="Wyżywienie"
											[(ngModel)]="event.board"
											bindLabel="name"
											[multiple]="false"
											[disabled]="lockEdit"
											required
										>
											<ng-option *ngFor="let item of board" [value]="item.id">{{
												item.name
											}}</ng-option>
										</ng-select>
									</div>
									<div class="col">
										<span
											class="btn"
											[ngClass]="{
												'btn-success': event.services_confirmed,
												'btn-outline-danger': !event.services_confirmed,
											}"
											(click)="event.services_confirmed = !event.services_confirmed"
											>Potwierdzone świadczenie
										</span>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<label class="form-label" for="noclegWydarzenia_sale ">
											Noclegi dla grupy adres/ załogi</label
										>
										<ckeditor
											id="noclegWydarzenia_sale"
											name="noclegWydarzenia_sale"
											[(ngModel)]="event.accommodation_detail"
											[editor]="editor"
											[disabled]="lockEdit"
											[config]="editorConfig"
										></ckeditor>
									</div>
								</div>
								<div class="mt-3">
									<label for="reconciliation_type"> Rozliczanie opłat drogowych</label>
								</div>
								<div class="form-floating mt-2 mb-3">
									<select
										class="form-select"
										id="reconciliation_type"
										name="reconciliation_type"
										[(ngModel)]="event.reconciliation_type"
									>
										<option value="0">Brak</option>
										<option value="1">Kierowca nie pobiera żadnych opłat</option>
										<option value="2">Kierowca pobiera opłaty</option>
										<option value="3">Opłaty fakturowane są po wyjeździe</option>
									</select>
								</div>
								<div class="mb-3">
									<label class="form-label" for="Uwagi">Uwagi</label>
									<ckeditor
										class="col-sm-9"
										id="Uwagi"
										name="Uwagi"
										[(ngModel)]="event.reconciliation_comments"
										[editor]="editor"
										[disabled]="lockEdit"
										[config]="editorConfig"
									></ckeditor>
								</div>
							</div>
						</div>
						<div class="card mb-3" id="text_refuling">
							<div class="card-body">
								<div class="mb-3">
									<label class="form-label labelcard" for="text_refuling">Tankowanie</label>
									<ckeditor
										class="col-sm-9"
										id="text_refuling"
										name="text_refuling"
										[(ngModel)]="event.text_refueling"
										[editor]="editor"
										[disabled]="lockEdit"
										[config]="editorConfig"
									></ckeditor>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
			<div class="tab-pane fade" id="program" role="tabpanel" aria-labelledby="program-tab">
				<fieldset [disabled]="lockEdit">
					<div class="row">
						<div class="col-8">
							<div class="form-floating mb-3">
								<input
									type="text"
									class="form-control"
									name="startPlace"
									id="startPlace"
									[(ngModel)]="event.startPlace"
									(change)="startPlaceChanged()"
								/>
								<label for="startPlace">Miejsce podstawienia (dokładny adres)</label>
							</div>
						</div>
						<div class="col-4">
							<div class="form-floating mb-3">
								<input
									type="text"
									class="form-control"
									name="startPostCode"
									id="startPostCode"
									[(ngModel)]="event.startPostCode"
									(change)="startPlaceChanged()"
								/>
								<label for="startPostCode">Kod pocztowy</label>
							</div>
						</div>
					</div>
					<div class="form-floating mb-3">
						<input
							type="datetime-local"
							class="form-control"
							name="startDate"
							id="startDate"
							[ngModel]="event.startDate | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="event.startDate = $event"
						/>
						<label for="startDate">Data podstawienia</label>
					</div>
					<div class="row mb-3">
						<div class="col-11">
							<label class="form-label" for="trasaWyjazd">Trasa/rozkład wyjazd</label>
							<ckeditor
								id="trasaWyjazd"
								name="trasaWyjazd"
								[(ngModel)]="event.text_departure"
								[editor]="editor"
								[disabled]="lockEdit"
								[config]="editorConfig"
							></ckeditor>
						</div>
						<div
							class="col-1 text-center align-self-center cursor-pointer"
							(click)="reportErrorOpen('text_departure', 'Trasa/rozkład wyjazd')"
						>
							<i class="fas fa-exclamation-triangle text-info"></i>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-11">
							<label class="form-label" for="programWyjazdu">Program wyjazdu</label>
							<ckeditor
								id="programWyjazdu"
								name="programWyjazdu"
								[(ngModel)]="event.text_program"
								[editor]="editor"
								[disabled]="lockEdit"
								[config]="editorConfig"
							></ckeditor>
						</div>
						<div
							class="col-1 text-center align-self-center cursor-pointer"
							(click)="reportErrorOpen('text_program', 'Program wyjazdu')"
						>
							<i class="fas fa-exclamation-triangle text-info"></i>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-11">
							<label class="form-label" for="trasaPowrót">Trasa/rozkład powrót</label>
							<ckeditor
								id="trasaPowrót"
								name="trasaPowrót"
								[(ngModel)]="event.text_return"
								[editor]="editor"
								[disabled]="lockEdit"
								[config]="editorConfig"
							></ckeditor>
						</div>
						<div
							class="col-1 text-center align-self-center cursor-pointer"
							(click)="reportErrorOpen('text_return', 'Trasa/rozkład powrót')"
						>
							<i class="fas fa-exclamation-triangle text-info"></i>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-8">
							<div class="form-floating mb-3">
								<input
									type="text"
									class="form-control"
									name="endPlace"
									id="endPlace"
									[(ngModel)]="event.endPlace"
								/>
								<label for="endPlace">Miejsce odstawienia</label>
							</div>
						</div>
						<div class="col-4">
							<div class="form-floating mb-3">
								<input
									type="text"
									class="form-control"
									name="endPostCode"
									id="endPostCode"
									[(ngModel)]="event.endPostCode"
								/>
								<label for="endPostCode">Kod pocztowy</label>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<label class="form-label" for="Tankowanie">Tankowanie</label>
						<ckeditor
							class="col-sm-9"
							id="Tankowanie"
							name="Tankowanie"
							[(ngModel)]="event.text_refueling"
							[editor]="editor"
							[disabled]="lockEdit"
							[config]="editorConfig"
						></ckeditor>
					</div>
					<div class="row mb-3">
						<div class="col-11">
							<div class="form-floating">
								<textarea
									class="form-control"
									id="client_wishes_program"
									name="client_wishes_program"
									[(ngModel)]="event.client_wishes"
								></textarea>
								<label for="client_wishes_program">Wymagania klienta i świadczenia</label>
							</div>
						</div>
						<div
							class="col-1 text-center align-self-center cursor-pointer"
							(click)="reportErrorOpen('client_wishes', 'Wymagania klienta i świadczenia')"
						>
							<i class="fas fa-exclamation-triangle text-info"></i>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-11">
							<div class="form-floating">
								<input
									type="text"
									class="form-control"
									name="client_representative"
									id="client_representative"
									[(ngModel)]="event.client_representative"
								/>
								<label for="client_representative">Klient - przedstawiciel na miejscu</label>
							</div>
						</div>
						<div
							class="col-1 text-center align-self-center cursor-pointer"
							(click)="reportErrorOpen('client_representative', 'Klient - przedstawiciel na miejscu')"
						>
							<i class="fas fa-exclamation-triangle text-info"></i>
						</div>
					</div>
				</fieldset>
			</div>

			<div class="tab-pane fade" id="drivers" role="tabpanel" aria-labelledby="drivers-tab">
				<fieldset [disabled]="lockEdit">
					<div class="mb-3 col-auto">
						<span
							class="btn"
							[ngClass]="{
								'btn-success': event.driver_informed_departure,
								'btn-outline-danger': !event.driver_informed_departure,
							}"
							(click)="driverInformed('driver_informed_departure')"
							>Kierowca poinformowany (wyjazd)</span
						>
					</div>
					<div class="card mb-3">
						<div class="card-body">
							<div class="row col-7">
								<div class="col">
									<label class="form-label text-start">Kierowcy wyjazd</label>
								</div>
								<div class="col">
									<div
										class="btn btn-warning"
										*ngIf="!lockEdit"
										(click)="addDriverEvent('before', 'drivers_departure')"
									>
										Dodaj wydarzenie przed
									</div>
								</div>
								<div class="col">
									<div
										class="btn btn-warning"
										*ngIf="!lockEdit"
										(click)="addDriverEvent('after', 'drivers_departure')"
									>
										Dodaj wydarzenie po
									</div>
								</div>
							</div>
							<div
								class="row mt-2"
								*ngFor="let driver of event.drivers_departure; let driverIndex = index"
							>
								<div class="col">
									<label for="program_date_from">Kierowca</label>
									<ng-select
										name="driversDeparture_{{ driverIndex }}"
										[(ngModel)]="event.drivers_departure[driverIndex].driver"
										(change)="
											checkConfirmSalaryDrivers(driver);
											checkEditedDriverDocument(event);
											changeDriver(driver)
										"
										(focus)="onFocusedDriver(event.drivers_departure[driverIndex].driver)"
										placeholder="(wybierz)"
										bindLabel="name"
										[disabled]="lockEdit || driver?.confirmed"
									>
										<ng-option *ngFor="let item of drivers" [value]="item.id"
											>{{ item.last_name }} {{ item.first_name }}</ng-option
										>
									</ng-select>
									<a class="cursor-pointer" (click)="driverModalOpen(driver)" *ngIf="lockEdit"
										>Czas pracy kierowcy</a
									>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}_date_from">Data od</label>
									<input
										type="datetime-local"
										class="col-sm-2 form-control"
										name
										name="drivers_departure_{{ driverIndex }}_date_from"
										id="drivers_departure_{{ driverIndex }}_date_from"
										[ngModel]="driver.date_from | date: 'yyyy-MM-ddTHH:mm'"
										(ngModelChange)="driver.date_from = $event"
										(change)="checkConfirmSalaryDrivers(driver); checkEditedDriverDocument(event)"
										[readonly]="driver.dateFromAuto"
										[disabled]="lockEdit || driver?.confirmed"
									/>
									<div class="col form-check mt-1">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="driver.dateFromAuto"
											(change)="
												autoDate('drivers_departure', driver, 'dateFromAuto', 'date_from');
												checkEditedDriverDocument(event)
											"
											name="drivers_departure_{{ driverIndex }}_dateFromAuto"
											id="drivers_departure_{{ driverIndex }}_dateFromAuto"
											[disabled]="lockEdit || driver?.confirmed"
										/>
										<label
											class="form-check-label"
											for="drivers_departure_{{ driverIndex }}_dateFromAuto"
										>
											Automatyczna "Data od"
										</label>
									</div>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}_date_to">Data do</label>
									<input
										type="datetime-local"
										class="col-sm-2 form-control"
										name="drivers_departure_{{ driverIndex }}_date_to"
										id="drivers_departure_{{ driverIndex }}_date_to"
										[ngModel]="driver.date_to | date: 'yyyy-MM-ddTHH:mm'"
										(ngModelChange)="driver.date_to = $event"
										(change)="checkConfirmSalaryDrivers(driver); checkEditedDriverDocument(event)"
										[readonly]="driver.dateToAuto"
										[disabled]="lockEdit || driver?.confirmed"
									/>
									<div class="col form-check mt-1">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="driver.dateToAuto"
											(change)="
												autoDate('drivers_departure', driver, 'dateToAuto', 'date_to');
												checkConfirmSalaryDrivers(driver);
												checkEditedDriverDocument(event)
											"
											name="drivers_departure_{{ driverIndex }}_dateToAuto"
											id="drivers_departure_{{ driverIndex }}_dateToAuto"
											[disabled]="lockEdit || driver?.confirmed"
										/>
										<label
											class="form-check-label"
											for="drivers_departure_{{ driverIndex }}_dateToAuto"
										>
											Automatyczna "Data do"
										</label>
									</div>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}_phoneNumber"
										>Nr tel (służbowy)</label
									>
									<p
										class="cursor-copy"
										[cdkCopyToClipboard]="driversById[driver.driver]?.phone_business"
									>
										{{
											!driversById[driver.driver]?.phone_business
												? 'Brak'
												: driversById[driver.driver]?.phone_business
										}}
									</p>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}_phoneNumber"
										>Nr tel (prywatny)</label
									>
									<p
										class="cursor-copy"
										[cdkCopyToClipboard]="driversById[driver.driver]?.phone_private"
									>
										{{
											!driversById[driver.driver]?.phone_private
												? 'Brak'
												: driversById[driver.driver]?.phone_private
										}}
									</p>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}email">Email</label>
									<p
										class="cursor-copy"
										[cdkCopyToClipboard]="driversById[driver.driver]?.email_business"
									>
										{{
											!driversById[driver.driver]?.email_business
												? 'Brak'
												: driversById[driver.driver]?.email_business
										}}
									</p>
								</div>
								<div class="col">
									<div
										class="btn btn-danger mt-4"
										(click)="deleteDriver('drivers_departure', driver)"
										*ngIf="!driver.confirmed && !lockEdit"
									>
										Usuń kierowce
									</div>
									<div class="mt-4">
										<a
											target="_blank"
											routerLink="/drivers-calendar/{{ driver.date_from | date: 'yyyy-MM-dd' }}"
											[fragment]="driver.driver"
											*ngIf="lockEdit"
										>
											<i class="far fa-calendar-alt"></i>
										</a>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col mt-2">
									<div
										class="btn btn-primary"
										(click)="driverAddRow('drivers_departure')"
										*ngIf="!lockEdit"
									>
										Dodaj kierowce
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mb-3">
						<div class="card-body">
							<div class="row col-7">
								<div class="col">
									<label class="form-label text-start">Kierowcy program</label>
								</div>
								<div class="col item-end">
									<div
										class="btn btn-warning"
										*ngIf="!lockEdit"
										(click)="addDriverEvent('before', 'drivers_program')"
									>
										Dodaj wydarzenie przed
									</div>
								</div>
								<div class="col item-start">
									<div
										class="btn btn-warning"
										*ngIf="!lockEdit"
										(click)="addDriverEvent('after', 'drivers_program')"
									>
										Dodaj wydarzenie po
									</div>
								</div>
							</div>
							<div class="row mt-2" *ngFor="let driver of event.drivers_program; let driverIndex = index">
								<div class="col-sm-3">
									<label for="program_date_from">Kierowca</label>
									<ng-select
										name="driversProgram_{{ driverIndex }}"
										[(ngModel)]="event.drivers_program[driverIndex].driver"
										placeholder="(wybierz)"
										(change)="
											checkConfirmSalaryDrivers(driver);
											checkEditedDriverDocument(event);
											changeDriver(driver)
										"
										(focus)="onFocusedDriver(event.drivers_program[driverIndex].driver)"
										bindLabel="name"
										[ngClass]="{
											error: this.errors.name,
										}"
										[disabled]="lockEdit || driver?.confirmed"
									>
										<ng-option *ngFor="let item of drivers" [value]="item.id"
											>{{ item.last_name }} {{ item.first_name }}</ng-option
										>
									</ng-select>
									<a class="cursor-pointer" (click)="driverModalOpen(driver)" *ngIf="lockEdit"
										>Czas pracy kierowcy</a
									>
								</div>
								<div class="col">
									<label for="drivers_program_{{ driverIndex }}_date_from">Data od</label>
									<input
										type="datetime-local"
										class="col-sm-2 form-control"
										name="drivers_program_{{ driverIndex }}_date_from"
										id="drivers_program_{{ driverIndex }}_date_from"
										[ngModel]="driver.date_from | date: 'yyyy-MM-ddTHH:mm'"
										(ngModelChange)="driver.date_from = $event"
										(change)="checkConfirmSalaryDrivers(driver); checkEditedDriverDocument(event)"
										[readonly]="driver.dateFromAuto"
										[disabled]="lockEdit || driver?.confirmed"
									/>
									<div class="col form-check mt-1">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="driver.dateFromAuto"
											(change)="
												autoDate('drivers_program', driver, 'dateFromAuto', 'date_from');
												checkEditedDriverDocument(event)
											"
											name="drivers_program_{{ driverIndex }}_dateFromAuto"
											id="drivers_program_{{ driverIndex }}_dateFromAuto"
											[disabled]="lockEdit || driver?.confirmed"
										/>
										<label
											class="form-check-label"
											for="drivers_program_{{ driverIndex }}_dateFromAuto"
										>
											Automatyczna "Data od"
										</label>
									</div>
								</div>
								<div class="col">
									<label for="drivers_program_{{ driverIndex }}_date_to">Data do</label>
									<input
										type="datetime-local"
										class="col-sm-2 form-control"
										name="drivers_program_{{ driverIndex }}_date_to"
										id="drivers_program_{{ driverIndex }}_date_to"
										[ngModel]="driver.date_to | date: 'yyyy-MM-ddTHH:mm'"
										(ngModelChange)="driver.date_to = $event"
										(change)="checkConfirmSalaryDrivers(driver); checkEditedDriverDocument(event)"
										[readonly]="driver.dateToAuto"
										[disabled]="lockEdit || driver?.confirmed"
									/>
									<div class="col form-check mt-1">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="driver.dateToAuto"
											(change)="
												autoDate('drivers_program', driver, 'dateToAuto', 'date_to');
												checkEditedDriverDocument(event)
											"
											name="drivers_program_{{ driverIndex }}_dateToAuto"
											id="drivers_program_{{ driverIndex }}_dateToAuto"
											[disabled]="lockEdit || driver?.confirmed"
										/>
										<label
											class="form-check-label"
											for="drivers_program_{{ driverIndex }}_dateToAuto"
										>
											Automatyczna "Data do"
										</label>
									</div>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}_phoneNumber">Numer tel</label>
									<p>
										{{
											!driversById[driver.driver]?.phone_business
												? 'Brak'
												: driversById[driver.driver]?.phone_business
										}}
									</p>
									<button [cdkCopyToClipboard]="driversById[driver.driver]?.phone_business">
										Skopiuj
									</button>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}email">Email</label>
									<p>
										{{
											!driversById[driver.driver]?.email_business
												? 'Brak'
												: driversById[driver.driver]?.email_business
										}}
									</p>
									<button [cdkCopyToClipboard]="driversById[driver.driver]?.email_business">
										Skopiuj
									</button>
								</div>
								<div class="col">
									<div
										class="btn btn-danger mt-4"
										(click)="deleteDriver('drivers_program', driver)"
										*ngIf="!driver.confirmed && !lockEdit"
									>
										Usuń kierowce
									</div>
									<div class="mt-4">
										<a
											target="_blank"
											routerLink="/drivers-calendar/{{ driver.date_from | date: 'yyyy-MM-dd' }}"
											[fragment]="driver.driver"
											*ngIf="lockEdit"
										>
											<i class="far fa-calendar-alt"></i>
										</a>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col mt-2">
									<div
										class="btn btn-primary"
										(click)="driverAddRow('drivers_program')"
										*ngIf="!lockEdit"
									>
										Dodaj kierowce
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mb-3 col-auto">
						<span
							class="btn"
							[ngClass]="{
								'btn-success': event.driver_informed_return,
								'btn-outline-danger': !event.driver_informed_return,
							}"
							(click)="driverInformed('driver_informed_return')"
							>Kierowca poinformowany (powrót)</span
						>
					</div>
					<div class="card mb-3">
						<div class="card-body">
							<div class="row col-7">
								<div class="col">
									<label class="form-label text-start">Kierowcy powrót</label>
								</div>
								<div class="col item-end">
									<div
										class="btn btn-warning"
										*ngIf="!lockEdit"
										(click)="addDriverEvent('before', 'drivers_return')"
									>
										Dodaj wydarzenie przed
									</div>
								</div>
								<div class="col item-start">
									<div
										class="btn btn-warning"
										*ngIf="!lockEdit"
										(click)="addDriverEvent('after', 'drivers_return')"
									>
										Dodaj wydarzenie po
									</div>
								</div>
							</div>
							<div class="row mt-2" *ngFor="let driver of event.drivers_return; let driverIndex = index">
								<div class="col-sm-3">
									<label for="program_date_from">Kierowca</label>
									<ng-select
										name="driversReturn_{{ driverIndex }}"
										[(ngModel)]="event.drivers_return[driverIndex].driver"
										placeholder="(wybierz)"
										bindLabel="name"
										(change)="
											checkConfirmSalaryDrivers(driver);
											checkEditedDriverDocument(event);
											changeDriver(driver)
										"
										(focus)="onFocusedDriver(event.drivers_return[driverIndex].driver)"
										[disabled]="lockEdit || driver?.confirmed"
									>
										<ng-option *ngFor="let item of drivers" [value]="item.id"
											>{{ item.last_name }} {{ item.first_name }}</ng-option
										>
									</ng-select>
									<a class="cursor-pointer" (click)="driverModalOpen(driver)" *ngIf="lockEdit"
										>Czas pracy kierowcy</a
									>
								</div>
								<div class="col">
									<label for="drivers_return_{{ driverIndex }}_date_from">Data od</label>
									<input
										type="datetime-local"
										class="col-sm-2 form-control"
										name="drivers_return_{{ driverIndex }}_date_from"
										id="drivers_return_{{ driverIndex }}_date_from"
										[ngModel]="driver.date_from | date: 'yyyy-MM-ddTHH:mm'"
										(ngModelChange)="driver.date_from = $event"
										[readonly]="driver.dateFromAuto"
										[disabled]="lockEdit || driver?.confirmed"
									/>
									<div class="col form-check mt-1">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="driver.dateFromAuto"
											(change)="
												autoDate('drivers_return', driver, 'dateFromAuto', 'date_from');
												checkEditedDriverDocument(event);
												checkConfirmSalaryDrivers(driver)
											"
											name="drivers_return_{{ driverIndex }}_dateFromAuto"
											id="drivers_return_{{ driverIndex }}_dateFromAuto"
											[disabled]="lockEdit || driver?.confirmed"
										/>
										<label
											class="form-check-label"
											for="drivers_return_{{ driverIndex }}_dateFromAuto"
										>
											Automatyczna "Data od"
										</label>
									</div>
								</div>
								<div class="col">
									<label for="drivers_return_{{ driverIndex }}_date_to">Data do</label>
									<input
										type="datetime-local"
										class="col-sm-2 form-control"
										name="drivers_return_{{ driverIndex }}_date_to"
										id="drivers_return_{{ driverIndex }}_date_to"
										[ngModel]="driver.date_to | date: 'yyyy-MM-ddTHH:mm'"
										(ngModelChange)="driver.date_to = $event"
										(change)="checkConfirmSalaryDrivers(driver); checkEditedDriverDocument(event)"
										[readonly]="driver.dateToAuto"
										[disabled]="lockEdit || driver?.confirmed"
									/>
									<div class="col form-check mt-1">
										<input
											class="form-check-input"
											type="checkbox"
											[(ngModel)]="driver.dateToAuto"
											(change)="
												autoDate('drivers_return', driver, 'dateToAuto', 'date_to');
												checkEditedDriverDocument(event);
												checkConfirmSalaryDrivers(driver)
											"
											name="drivers_return_{{ driverIndex }}_dateToAuto"
											id="drivers_return_{{ driverIndex }}_dateToAuto"
											[disabled]="lockEdit || driver?.confirmed"
										/>
										<label
											class="form-check-label"
											for="drivers_return_{{ driverIndex }}_dateToAuto"
										>
											Automatyczna "Data do"
										</label>
									</div>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}_phoneNumber">Numer tel</label>
									<p>
										{{
											!driversById[driver.driver]?.phone_business
												? 'Brak'
												: driversById[driver.driver]?.phone_business
										}}
									</p>
									<button [cdkCopyToClipboard]="driversById[driver.driver]?.phone_business">
										Skopiuj
									</button>
								</div>
								<div class="col">
									<label for="drivers_departure_{{ driverIndex }}email">Email</label>
									<p>
										{{
											!driversById[driver.driver]?.email_business
												? 'Brak'
												: driversById[driver.driver]?.email_business
										}}
									</p>
									<button [cdkCopyToClipboard]="driversById[driver.driver]?.email_business">
										Skopiuj
									</button>
								</div>
								<div class="col">
									<div
										class="btn btn-danger mt-4"
										(click)="deleteDriver('drivers_return', driver)"
										*ngIf="!driver.confirmed && !lockEdit"
									>
										Usuń kierowce
									</div>
									<div class="mt-4">
										<a
											target="_blank"
											routerLink="/drivers-calendar/{{ driver.date_from | date: 'yyyy-MM-dd' }}"
											[fragment]="driver.driver"
											*ngIf="lockEdit"
										>
											<i class="far fa-calendar-alt"></i>
										</a>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col mt-2">
									<div
										class="btn btn-primary"
										(click)="driverAddRow('drivers_return')"
										*ngIf="!lockEdit"
									>
										Dodaj kierowce
									</div>
								</div>
							</div>
						</div>
					</div>
					<label class="form-label" for="kierowcy">Kierowcy uwagi</label>
					<ckeditor
						class="col-sm-9"
						id="kierowcy"
						name="kierowcy"
						[(ngModel)]="event.text_drivers"
						[editor]="editor"
						[disabled]="lockEdit"
						[config]="editorConfig"
					></ckeditor>
				</fieldset>
			</div>

			<div class="tab-pane fade" id="settlement" role="tabpanel" aria-labelledby="settlement-tab">
				<fieldset [disabled]="lockEdit">
					<div class="mb-3">
						<label class="form-label" for="Klient">Klient</label>
						<ckeditor
							class="col-sm-9"
							id="Klient"
							name="Klient"
							[(ngModel)]="event.text_client"
							[editor]="editor"
							[disabled]="lockEdit"
							[config]="editorConfig"
						></ckeditor>
					</div>
					<div class="form-check mb-3">
						<input
							class="form-check-input"
							type="checkbox"
							name="invoiceRequired"
							[(ngModel)]="event.invoiceRequired"
							id="invoiceRequired"
							(change)="calculateDatePrepare()"
						/>
						<label class="form-check-label" for="invoiceRequired"> Wymagana FV </label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							name="invoiceRequiredNote"
							id="invoiceRequiredNote"
							[(ngModel)]="event.invoiceRequiredNote"
						/>
						<label for="invoiceRequiredNote">Powód braku FV</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							name="agreement_signature"
							id="agreement_signature"
							[(ngModel)]="event.agreement_signature"
						/>
						<label for="agreement_signature">Link do umowy</label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							name="calculation_link"
							id="calculation_link"
							[(ngModel)]="event.calculation_link"
						/>
						<label for="calculation_link">Link do kalkulacji</label>
					</div>
					<div class="row align-items-center mb-3">
						<div class="col-4">
							<div class="form-floating">
								<input
									type="number"
									min="0"
									step="0.01"
									class="form-control"
									name="agreement_value"
									id="agreement_value"
									[(ngModel)]="event.agreement_value"
									(ngModelChange)="onAgreementValueChange()"
								/>
								<label for="agreement_value">Kwota na umowie / Przychód</label>
							</div>
						</div>
						<div class="col-2">
							<div class="form-floating">
								<select
									class="form-select"
									id="agreement_value_currency"
									name="agreement_value_currency"
									[(ngModel)]="event.agreement_value_currency"
									(change)="onAgreementValueCurrencyChange()"
								>
									<option value="PLN">PLN</option>
									<option value="EUR">EUR</option>
								</select>
								<label for="agreement_value_currency">Waluta</label>
							</div>
						</div>
						@if (event.agreement_value_currency === CURRENCY_EUR) {
							<div class="col-3">
								<div class="form-floating">
									<input
										type="text"
										class="form-control"
										id="agreement_value_pln"
										[value]="event.agreement_value_pln !== null ? event.agreement_value_pln : ''"
										disabled
									/>
									<label for="agreement_value_pln">Wartość w PLN</label>
								</div>
							</div>
						}
						@if (event.agreement_value_currency === CURRENCY_EUR && agreementValueRateDate) {
							<div class="col-2">
								<small class="text-muted">Kurs z dnia: {{ agreementValueRateDate }}</small>
							</div>
						}
						<div
							class="col-1 text-center cursor-pointer"
							(click)="reportErrorOpen('agreement_value', 'Kwota na umowie')"
						>
							<i class="fas fa-exclamation-triangle text-info"></i>
						</div>
					</div>
					<div class="row align-items-center mb-3">
						<div class="col-4">
							<div class="form-floating">
								<input
									type="number"
									min="0"
									step="0.01"
									class="form-control"
									name="predicted_profit"
									id="predicted_profit"
									[(ngModel)]="event.predicted_profit"
									(ngModelChange)="onPredictedProfitChange()"
								/>
								<label for="predicted_profit">Prognozowany zysk</label>
							</div>
						</div>
						<div class="col-2">
							<div class="form-floating">
								<select
									class="form-select"
									id="predicted_profit_currency"
									name="predicted_profit_currency"
									[(ngModel)]="event.predicted_profit_currency"
									(change)="onPredictedProfitCurrencyChange()"
								>
									<option value="PLN">PLN</option>
									<option value="EUR">EUR</option>
								</select>
								<label for="predicted_profit_currency">Waluta</label>
							</div>
						</div>
						@if (event.predicted_profit_currency === CURRENCY_EUR) {
							<div class="col-3">
								<div class="form-floating">
									<input
										type="text"
										class="form-control"
										id="predicted_profit_pln"
										[value]="event.predicted_profit_pln !== null ? event.predicted_profit_pln : ''"
										disabled
									/>
									<label for="predicted_profit_pln">Wartość w PLN</label>
								</div>
							</div>
						}
						@if (event.predicted_profit_currency === CURRENCY_EUR && predictedProfitRateDate) {
							<div class="col-3">
								<small class="text-muted">Kurs z dnia: {{ predictedProfitRateDate }}</small>
							</div>
						}
					</div>
					<div class="form-floating mb-3">
						<input
							type="number"
							min="0"
							class="form-control"
							name="agreement_mileage_limit"
							id="agreement_mileage_limit"
							[(ngModel)]="event.agreement_mileage_limit"
						/>
						<label for="agreement_mileage_limit">Limit kilometrów</label>
					</div>
					<div class="mb-3">
						<label class="form-label" for="dzialRozliczen">Dział rozliczeń</label>
						<ckeditor
							class="col-sm-9"
							id="dzialRozliczen"
							name="dzialRozliczen"
							[(ngModel)]="event.text_billing"
							[editor]="editor"
							[disabled]="lockEdit"
							[config]="editorConfig"
						></ckeditor>
					</div>
					<div class="mb-3">
						<label class="form-label" for="Uwagi">Uwagi</label>
						<ckeditor
							class="col-sm-9"
							id="Uwagi"
							name="Uwagi"
							[(ngModel)]="event.text_notes"
							[editor]="editor"
							[disabled]="lockEdit"
							[config]="editorConfig"
						></ckeditor>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							id="client_wishes"
							name="client_wishes"
							[(ngModel)]="event.client_wishes"
						></textarea>
						<label for="client_wishes">Wymagania klienta i świadczenia</label>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							id="text_opinion"
							name="text_opinion"
							[(ngModel)]="event.text_opinion"
						></textarea>
						<label for="text_opinion">Opinia po wyjeździe</label>
					</div>
				</fieldset>
			</div>

			<div class="tab-pane fade" id="briefing" role="tabpanel" aria-labelledby="briefing-tab">
				<fieldset [disabled]="lockEdit">
					<div class="form-floating mb-3">
						<input
							type="datetime-local"
							class="form-control"
							name="date_prepare"
							id="date_prepare"
							[ngModel]="event.date_prepare | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="event.date_prepare = $event"
							[readonly]="event.datePrepareAuto"
						/>
						<label for="date_prepare">Data odprawy</label>
					</div>
					<div class="form-check mb-3">
						<input
							class="form-check-input"
							type="checkbox"
							name="datePrepareAuto"
							[(ngModel)]="event.datePrepareAuto"
							id="datePrepareAuto"
							(change)="calculateDatePrepare()"
						/>
						<label class="form-check-label" for="datePrepareAuto"> Automatyczna data odprawy </label>
					</div>
					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							name="briefingPlace"
							id="briefingPlace"
							[(ngModel)]="event.briefingPlace"
						/>
						<label for="briefingPlace">Miejsce odprawy</label>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							name="textBriefing"
							id="textBriefing"
							[(ngModel)]="event.textBriefing"
						></textarea>
						<label for="textBriefing">Uwagi do odprawy</label>
					</div>

					<div class="form-floating mb-3">
						<input
							type="text"
							class="form-control"
							name="place_return"
							id="place_return"
							[(ngModel)]="event.place_return"
						/>
						<label for="place_return">Miejsce powrotu</label>
					</div>
					<div class="mb-3">
						<label class="form-label" for="briefingUser">Odprawjiający</label>
						<ng-select
							id="briefingUser"
							name="briefingUser"
							[(ngModel)]="event.briefingUser"
							bindLabel="name"
							[disabled]="lockEdit"
						>
							<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</fieldset>
			</div>

			<div class="tab-pane fade" id="organisation" role="tabpanel" aria-labelledby="organisation-tab">
				<fieldset [disabled]="lockEdit">
					<div class="form-floating mb-3">
						<span
							class="btn"
							[ngClass]="{
								'btn-success': event.guide_informed,
								'btn-outline-danger': !event.guide_informed,
							}"
							(click)="event.guide_informed = !event.guide_informed"
							>Pilot poinformowany (wyjazd)</span
						>
					</div>
					<div class="form-floating mb-3">
						<span
							class="btn"
							[ngClass]="{
								'btn-success': event.guide_informed_return,
								'btn-outline-danger': !event.guide_informed_return,
							}"
							(click)="event.guide_informed_return = !event.guide_informed_return"
							>Pilot poinformowany (powrót)</span
						>
					</div>
					<div class="mb-3">
						<label class="form-label" for="organizationOwner">Opiekun Organizacji</label>
						<ng-select
							id="organizationOwner"
							name="organizationOwner"
							[(ngModel)]="event.organizationOwner"
							placeholder="(wybierz)"
							bindLabel="name"
							[disabled]="lockEdit"
							[multiple]="true"
						>
							<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							id="organizacja"
							name="organizacja"
							[(ngModel)]="event.text_organization"
						></textarea>
						<label for="organizacja">Uwagi Organizacji</label>
					</div>
					<div class="form-floating mb-3">
						<input
							class="form-control"
							id="noclegWydarzenia"
							name="noclegWydarzenia"
							[(ngModel)]="event.accommodation"
						/>
						<label for="noclegWydarzenia">Nocleg</label>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							id="text_hotel"
							name="text_hotel"
							[(ngModel)]="event.text_hotel"
						></textarea>
						<label for="text_hotel">Info o hotelach</label>
					</div>
					<div class="mb-3">
						<label class="form-label" for="touristGuidesDeparture">Piloci wyjazd</label>
						<ng-select
							id="touristGuidesDeparture"
							name="touristGuidesDeparture"
							[(ngModel)]="event.tourist_guides_departure"
							placeholder="(wybierz)"
							[multiple]="true"
							bindLabel="name"
							[disabled]="lockEdit"
						>
							<ng-option *ngFor="let item of touristGuides" [value]="item.id"
								>{{ item.lastName }} {{ item.firstName }}</ng-option
							>
						</ng-select>
					</div>
					<div class="mb-3">
						<label class="form-label" for="touristGuidesProgram">Piloci program</label>
						<ng-select
							id="touristGuidesProgram"
							name="touristGuidesProgram"
							[(ngModel)]="event.tourist_guides_program"
							placeholder="(wybierz)"
							[multiple]="true"
							bindLabel="name"
							[disabled]="lockEdit"
						>
							<ng-option *ngFor="let item of touristGuides" [value]="item.id"
								>{{ item.lastName }} {{ item.firstName }}</ng-option
							>
						</ng-select>
					</div>
					<div class="mb-3">
						<label class="form-label" for="touristGuidesReturn">Piloci powrót</label>
						<ng-select
							id="touristGuidesReturn"
							name="touristGuidesReturn"
							[(ngModel)]="event.tourist_guides_return"
							placeholder="(wybierz)"
							[multiple]="true"
							bindLabel="name"
							[disabled]="lockEdit"
						>
							<ng-option *ngFor="let item of touristGuides" [value]="item.id"
								>{{ item.lastName }} {{ item.firstName }}</ng-option
							>
						</ng-select>
					</div>
					<div class="form-floating mb-3">
						<textarea
							class="form-control"
							id="text_guide"
							name="text_guide"
							[(ngModel)]="event.text_guide"
						></textarea>
						<label for="text_guide">Piloci uwagi</label>
					</div>
				</fieldset>
			</div>

			<div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab">
				<fieldset [disabled]="lockEdit">
					<div class="mb-3">
						<label class="form-label">Kierowca opiekun</label>
						<ng-select
							name="drivers_senior"
							[(ngModel)]="event.drivers_senior"
							placeholder="(wybierz)"
							[multiple]="true"
							bindLabel="name"
							[disabled]="lockEdit"
						>
							<ng-option *ngFor="let item of drivers" [value]="item.id">
								{{ item.last_name }} {{ item.first_name }}
							</ng-option>
						</ng-select>
					</div>
				</fieldset>
				<ul class="list-group">
					<li class="list-group-item">
						<a routerLink="documents/departureCard" target="_blank">Karta wyjazdu</a>
					</li>
					<li class="list-group-item">
						<a routerLink="documents/transportBriefing" target="_blank">Protokół przewozu</a>
					</li>
					<li class="list-group-item">
						<a routerLink="documents/transportCheckOut" target="_blank">Odprawa</a>
					</li>
					<li class="list-group-item">
						<a routerLink="documents/top" target="_blank">Strona na teczkę</a>
					</li>
				</ul>
			</div>
			<div class="tab-pane fade" id="tasks" role="tabpanel" aria-labelledby="tasks-tab">
				<app-php-tasks objType="tourismEvent" [objId]="event.id"></app-php-tasks>
			</div>
		</div>
	</form>
</div>
